import React from 'react'
import { useTheme } from 'styled-components'
import { HeroSectionSlice } from './HeroSectionSlice'
import { HeroSectionDefault } from './HeroSectionDefault'

export const HeroSection: React.FC<{
  setVideoPlayerOpen: (open: boolean) => void
}> = ({ setVideoPlayerOpen }) => {
  const theme = useTheme()

  return theme.template === 'template-4' ? (
    <HeroSectionSlice />
  ) : (
    <HeroSectionDefault setVideoPlayerOpen={setVideoPlayerOpen} />
  )
}
